const Menu = [
  // ===== MAIN WORKFLOW =====
  { header: "Main", i18nKey: "main" },
  {
    title: "Requests",
    i18nKey: "requests",
    icon: "pin_drop",
    name: "Requests",
    permission: "BOOKINGS",
  },
  {
    title: "Create Booking",
    i18nKey: "createBooking",
    icon: "create",
    name: "CreateBooking",
    permission: "CREATE_BOOKING",
  },
  {
    title: "Bookings",
    i18nKey: "bookings",
    icon: "directions_car",
    name: "BookingsList",
    permission: "BOOKINGS",
  },
  {
    title: "Booking Complaints",
    i18nKey: "bookingComplaints",
    icon: "report_problem",
    name: "BookingComplaints",
    permission: "BOOKING_COMPLAINTS",
  },
  {
    title: "User Complaints",
    i18nKey: "userComplaints",
    icon: "feedback",
    name: "Complaints",
    permission: "COMPLAINTS",
  },
  {
    title: "Tracking",
    i18nKey: "tracking",
    icon: "map",
    name: "CaptainsMap",
    permission: "TRACKING",
  },

  // {
  //   title: "Timeline",
  //   icon: "timeline",
  //   name: "Timeline",
  //   permission: "TIMELINE",
  // },
  // {
  //   title: "Complaints",
  //   icon: "list",
  //   name: "ComplaintsList",
  //   permission: "COMPLAINTS",
  // },
  // // {
  // //     title: "Monitoring",
  // //     icon: "tv",
  // //     items: [
  // //         {
  // //             title: "Map",
  // //             name: "Map",
  // //             permission: "MONITORING"
  // //         },
  // //         {
  // //             title: "Monitor",
  // //             name: "Monitor",
  // //             permission: "MONITORING"
  // //         },
  // //         // {
  // //         //     title: "Lateness",
  // //         //     name: "Lateness",
  // //         //     permission: "LATENESS"
  // //         // },
  // //         // {
  // //         //     title: "Notification Centre",
  // //         //     name: "NotificationCentre",
  // //         //     permission: "MONITORING"
  // //         // },
  // //         {
  // //             title: "Rides Tracker",
  // //             name: "RidesTracker",
  // //             permission: "MONITORING"

  // //         },
  // //         {
  // //             title: "Path Drawer",
  // //             name: "PathDrawer",
  // //             permission: "MONITORING"
  // //         },
  // //         {
  // //             title: "Rides Search",
  // //             name: "RidesSearch",
  // //             permission: "MONITORING"
  // //         },
  // //         // {
  // //         //     title: "AI Stats",
  // //         //     name: "AiStats",
  // //         //     permission: "AI_STATS"
  // //         // },
  // //     ]
  // // },
  // ===== PEOPLE =====
  { header: "People", i18nKey: "people" },
  {
    title: "Staff",
    i18nKey: "staff",
    icon: "group",
    name: "Staff",
    permission: "STAFF",
  },
  {
    title: "Roles",
    i18nKey: "roles",
    icon: "security",
    name: "Roles",
    permission: "ROLES",
  },
  {
    name: "Drivers",
    title: "Drivers",
    i18nKey: "drivers",
    icon: "people",
    permission: "DRIVERS",
  },

  {
    title: "Passengers",
    i18nKey: "passengers",
    icon: "people",
    items: [
      {
        name: "Passengers",
        title: "Normal",
        i18nKey: "normal",
        permission: "PASSENGERS",
        icon: "people",
      },
      {
        name: "BusinessAccounts",
        title: "Business Wallets",
        i18nKey: "businessAccounts",
        permission: "PASSENGERS",
        icon: "people",
      },
    ],
  },
  {
    title: "Charge Centers",
    i18nKey: "transferCenters",
    icon: "swap_horiz",
    name: "TransferCenters",
    permission: "TRANSFER_CENTERS",
  },
  // ===== FINANCIAL =====
  { header: "Financial & Marketing", i18nKey: "financialMarketing" },

  {
    // The unified report catalog (requirements doc 2026-09-09). It sits at the
    // top level rather than inside Finance because it spans the operational,
    // driver, customer and charge-centre families as well as the financial
    // ones, and it carries NO permission on purpose -- exactly as the server's
    // catalog route does, which filters the list to the reports the caller may
    // open. Gating the item on any one permission would hide the catalog from
    // a reader who holds only the customer or driver reports.
    title: "Reports",
    i18nKey: "reportCatalog",
    icon: "assessment",
    name: "ReportCatalog",
  },

  {
    title: "Accounting",
    i18nKey: "accounting",
    icon: "attach_money",
    items: [
      {
        name: "DriversAccounting",
        title: "Drivers Accounting",
        i18nKey: "driversAccounting",
        icon: "attach_money",
        permission: "ACCOUNTING",
      },
      {
        name: "TransferCentersAccounting",
        title: "Charge Centers Accounting",
        i18nKey: "transferCentersAccounting",
        icon: "account_balance_wallet",
        permission: "ACCOUNTING",
      },
      {
        name: "CarOwners",
        title: "Car Owners",
        i18nKey: "carOwners",
        icon: "directions_car",
        permission: "CAR_OWNERS",
      },
      {
        name: "BusinessAccountBalances",
        title: "Business Wallet Balances",
        i18nKey: "businessBalances",
        icon: "account_balance_wallet",
        permission: "BUSINESS_ACCOUNTS",
      },
      {
        name: "PassengerWallets",
        title: "Passenger Wallets",
        i18nKey: "passengerWallets",
        icon: "account_balance_wallet",
        permission: "PASSENGERS",
      },
    ],
  },
  {
    title: "Transfers",
    i18nKey: "transfers",
    icon: "swap_horizontal_circle",
    items: [
      {
        name: "DriversTransfers",
        title: "Drivers Transfers",
        i18nKey: "driversTransfers",
        icon: "monetization_on",
        permission: "ACCOUNTING",
      },
      {
        name: "TransferCenterTransfers",
        title: "Charge Centers Transfers",
        i18nKey: "transferCentersTransfers",
        icon: "swap_horizontal_circle",
        permission: "ACCOUNTING",
      },
    ],
  },

  {
    title: "Finance",
    i18nKey: "finance",
    icon: "account_balance",
    items: [
      {
        // Lands on the captain balances list (Payments); the per-captain
        // ledger route needs a :captainId param so it can't be a menu target.
        title: "Captain Ledger",
        i18nKey: "captainLedger",
        name: "payments",
        icon: "receipt_long",
        permission: "VIEW_CAPTAIN_LEDGER",
      },
      {
        title: "Chart of Accounts",
        i18nKey: "chartOfAccounts",
        name: "ChartOfAccounts",
        icon: "account_tree",
        permission: "VIEW_CAPTAIN_LEDGER",
      },
      {
        title: "Journal Entries",
        i18nKey: "journalEntries",
        name: "JournalEntries",
        icon: "menu_book",
        permission: "VIEW_CAPTAIN_LEDGER",
      },
      {
        title: "Assets",
        i18nKey: "assets",
        name: "AssetEntries",
        icon: "savings",
        permission: "VIEW_CAPTAIN_LEDGER",
      },
      {
        title: "Adjustments",
        i18nKey: "adjustments",
        name: "CaptainAdjustments",
        icon: "tune",
        permission: "VIEW_CAPTAIN_LEDGER",
      },
      {
        title: "Auto Entries",
        i18nKey: "autoEntries",
        name: "PostingRules",
        icon: "auto_mode",
        permission: "VIEW_CAPTAIN_LEDGER",
      },
      {
        title: "Finance Reports",
        i18nKey: "financeReports",
        name: "FinanceReports",
        icon: "assessment",
        permission: "VIEW_CAPTAIN_LEDGER",
      },
      {
        // Gated on the reports permission (doc: accountant / financial
        // manager / super admin), unlike the older VIEW_CAPTAIN_LEDGER items.
        title: "Trial Balance",
        i18nKey: "trialBalance",
        name: "TrialBalance",
        icon: "balance",
        permission: "VIEW_FINANCE_REPORTS",
      },
      {
        title: "Balance Sheet",
        i18nKey: "balanceSheet",
        name: "BalanceSheet",
        icon: "account_balance",
        permission: "VIEW_FINANCE_REPORTS",
      },
      {
        title: "Income Statement",
        i18nKey: "incomeStatement",
        name: "IncomeStatement",
        icon: "trending_up",
        permission: "VIEW_FINANCE_REPORTS",
      },
      // Accountant's document 2026-10-03, section 2: the seven ledger reports.
      {
        title: "General Journal Summary",
        i18nKey: "generalJournalSummary",
        name: "GeneralJournalSummary",
        icon: "library_books",
        permission: "VIEW_FINANCE_REPORTS",
      },
      {
        title: "Driver Statement",
        i18nKey: "driverStatement",
        name: "DriverStatement",
        icon: "receipt",
        permission: "VIEW_FINANCE_REPORTS",
      },
      {
        title: "Cash Flow Statement",
        i18nKey: "cashFlowStatement",
        name: "CashFlowStatement",
        icon: "swap_vert",
        permission: "VIEW_FINANCE_REPORTS",
      },
      {
        title: "Changes in Equity",
        i18nKey: "equityChanges",
        name: "EquityChanges",
        icon: "pie_chart",
        permission: "VIEW_FINANCE_REPORTS",
      },
      {
        title: "Account Statement",
        i18nKey: "accountStatement",
        name: "AccountStatement",
        icon: "description",
        permission: "VIEW_FINANCE_REPORTS",
      },
      {
        title: "Accounting Balance",
        i18nKey: "accountingBalance",
        name: "AccountingBalance",
        icon: "account_balance_wallet",
        permission: "VIEW_FINANCE_REPORTS",
      },
      {
        title: "Accounts Inventory",
        i18nKey: "accountsInventory",
        name: "AccountsInventory",
        icon: "assignment",
        permission: "VIEW_FINANCE_REPORTS",
      },
      {
        // Closing a month refuses every later entry dated into it, so it is
        // gated on the journals permission, not the reports one.
        title: "Period Locks",
        i18nKey: "periodLocks",
        name: "PeriodLocks",
        icon: "lock_clock",
        permission: "MANAGE_FINANCE_JOURNALS",
      },
      {
        title: "Employees & Payroll",
        i18nKey: "employees",
        name: "Employees",
        icon: "badge",
        permission: "VIEW_FINANCE_REPORTS",
      },
    ],
  },
  {
    title: "Transfer Agent",
    i18nKey: "transferAgent",
    icon: "local_atm",
    name: "AgentPanel",
    permission: "TRANSFER_AGENT",
  },
  {
    title: "Statistics",
    i18nKey: "statistics",
    icon: "bar_chart",
    name: "AnalyticsSummary",
    permission: "STATISTICS",
  },
  {
    title: "Vouchers",
    i18nKey: "vouchers",
    icon: "money_off",
    items: [
      {
        title: "Marketing Vouchers",
        i18nKey: "marketingVouchers",
        name: "MarketingVouchers",
        permission: "MARKETING_VOUCHERS",
      },
      {
        title: "Personal Vouchers",
        i18nKey: "personalVouchers",
        name: "PersonalVouchers",
        permission: "PERSONAL_VOUCHERS",
      },
    ],
  },
  {
    title: "Passengers Marketing",
    i18nKey: "passengersMarketing",
    icon: "campaign",
    name: "PassengersMarketing",
    permission: "PASSENGERS_MARKETING",
  },

  // ===== OPERATIONS & CONFIGURATION =====
  { header: "Operations & Config", i18nKey: "operationsConfig" },
  {
    name: "Services",
    title: "Services",
    i18nKey: "services",
    icon: "miscellaneous_services",
    permission: "SERVICES",
  },
  {
    name: "Cameras",
    title: "Cameras",
    i18nKey: "cameras",
    icon: "videocam",
    permission: "SERVICES",
  },
  {
    name: "PaymentMethods",
    title: "Payment Methods",
    i18nKey: "paymentMethods",
    icon: "payment",
    permission: "PAYMENT_METHODS",
  },
  {
    title: "Zones",
    i18nKey: "zones",
    icon: "map",
    name: "Zones",
    permission: "ZONES",
  },
  {
    title: "Cancellation Reasons",
    i18nKey: "cancellationReasons",
    icon: "score",
    name: "CancellationReasons",
    permission: "CANCELLATION_REASONS",
  },
  {
    title: "Cars",
    i18nKey: "cars",
    icon: "select_all",
    items: [
      {
        title: "Car Brands",
        i18nKey: "carBrands",
        name: "CarBrands",
        permission: "CAR_BRANDS",
      },
      {
        title: "Car Colors",
        i18nKey: "carColors",
        name: "Colors",
        permission: "CAR_COLORS",
      },
      {
        // Fleet-entered, DRIVERS-gated (there is no CARS permission), but its
        // cost is what feeds maintenance expense account 51313.
        title: "Maintenance",
        i18nKey: "carMaintenance",
        name: "CarMaintenance",
        permission: "DRIVERS",
      },
      // {
      //   name: "VehicleTypesManagement",
      //   title: "Vehicle Types",
      //   permission: "VEHICLE_TYPE_MANAGEMENT",
      // },
    ],
  },
  {
    title: "Settings",
    i18nKey: "settings",
    icon: "settings",
    name: "Settings",
    permission: "SETTINGS",
  },
  // {
  //   name: "Messages",
  //   title: "Messages",
  //   icon: "message",
  //   permission: "MESSAGES",
  // },
  // {
  //   name: "DriversAnnouncements",
  //   title: "Drivers Announcements",
  //   icon: "mice",
  //   permission: "CAPTAINS",
  // },
  // {
  //   title: "Maps",
  //   icon: "map",
  //   items: [
  //     {
  //       name: "Locations",
  //       title: "Sectors",
  //       permission: "LOCATIONS",
  //     },
  //     {
  //       name: "stations",
  //       title: "Stations",
  //       permission: "LOCATIONS",
  //     },
  //     {
  //       name: "Landmarks",
  //       title: "Landmarks",
  //       permission: "LANDMARK_MANAGEMENT",
  //     },
  //     {
  //       title: "Map editor",
  //       name: "MapEditor",
  //       permission: "EDIT_MAP",
  //     },
  //     {
  //       title: "Destination editor",
  //       name: "EditSeasonalDestinations",
  //       permission: "EDIT_DESTINATION_SEASONAL",
  //     },
  //     {
  //       title: "Monaco editor",
  //       name: "MonacoEditor",
  //       permission: "EDIT_MAP",
  //     },
  //     {
  //       title: "Restricted Areas",
  //       name: "RestrictedAreas",
  //       permission: "RESTRICTED_AREA",
  //     },
  //   ],
  // },
  // // {
  // //     title: "Vouchers",
  // //     icon: "shopping_cart",
  // //     name: "Vouchers",
  // //     permission: "VOUCHERS",

  // // },
  // // {
  // //     title: "Captain Acquisition",
  // //     icon: "schedule",
  // //     items: [
  // //         {
  // //             title: "Available Times",
  // //             name: "AvailableInterviewTimes",
  // //             permission: "INTERVIEW_MANAGEMENT"
  // //         },
  // //         {
  // //             title: "Interviews",
  // //             name: "Interviews",
  // //             permission: "INTERVIEW_MANAGEMENT"
  // //         },
  // //         {
  // //             title: "Levels",
  // //             name: "Level",
  // //             permission: 'MANAGE_CONTRACT_TEMPLATES'
  // //         },
  // //         {
  // //             title: "Contract Template",
  // //             name: "contract_template",
  // //             permission: 'MANAGE_CONTRACT_TEMPLATES'
  // //         },
  // //     ]
  // // },
  // // {
  // //     title: "Accounting",
  // //     icon: "attach_money",
  // //     items: [
  // //         {
  // //             title: "Payments",
  // //             name: "Payments",
  // //             permission: "VIEW_PAYMENTS"
  // //         },
  // //         {
  // //             title: "Cash Registers",
  // //             name: "Cash Registers",
  // //             permission: "CASH_REGISTER"
  // //         },
  // //         {
  // //             title: "Pending C.R. Transactions",
  // //             name: "Pending Transactions",
  // //             permission: "CASH_REGISTER_MASTER"
  // //         },
  // //         {
  // //             title: "Bonus Requests",
  // //             name: "Bonus Requests",
  // //             permission: "MANAGE_TRANSACTION"
  // //         },
  // //         {
  // //             title: "Penalties & Bonuses",
  // //             name: "Transactions",
  // //             permission: "MANAGE_TRANSACTION"
  // //         },
  // //         {
  // //             name: "Bonus Package",
  // //             title: "Conditional Bonuses",
  // //             permission: 'CONDITIONAL_BONUS'
  // //         },
  // //         {
  // //             title: "Captain Balance",
  // //             name: "Captain Balance",
  // //             permission: "VIEW_PAYMENTS"
  // //         },
  // //     ]
  // // },
  // // {
  // //     title: "HR",
  // //     icon: "request_quote",
  // //     permission: 'MANAGE_HR',
  // //     items: [
  // //         {
  // //             title: "Employment types",
  // //             name: "EmploymentTypes",
  // //             permission: 'MANAGE_HR',
  // //         },
  // //         {
  // //             title: "Salary reports",
  // //             name: "SalariesReports",
  // //             permission: 'SALARIES_MONITORING',
  // //         },
  // //         {
  // //             title: "All Salaries reports",
  // //             name: "AllSalariesReports",
  // //             permission: 'SALARIES_MONITORING',
  // //         },
  // //         {
  // //             title: "Salary events",
  // //             name: "SalaryEvents",
  // //             permission: 'CAN_ADD_SALARY_EVENTS',
  // //         }
  // //     ]
  // // },

  // // {
  // //     title: "Customer Support",
  // //     icon: "contact_support",
  // //     items: [
  // //         // {
  // //         //     title: "First Ride Pax",
  // //         //     name: "FirstRidePax",
  // //         //     permission: "FIRST_RIDE_PAX"
  // //         // },
  // //         {
  // //             title: "Rating Causes",
  // //             name: "RatingCauses",
  // //             permission: 'CUSTOMER_SUPPORT'
  // //         },
  // //         {
  // //             title: "Tickets Management",
  // //             name: "TicketsManagement",
  // //             permission: 'TICKET_MANAGEMENT'
  // //         },
  // //         {
  // //             title: "Tickets",
  // //             name: "Tickets",
  // //             permission: 'TICKETING'
  // //         },
  // //         {
  // //             title: "Tickets Monitoring",
  // //             name: "TicketsMonitoring",
  // //             permission: 'OTHER_TICKETS'
  // //         }
  // //     ]
  // // },
  // {
  //   title: "Hotels",
  //   icon: "hotel",
  //   name: "Hotels",
  //   permission: "ACCOMMODATION",
  // },
  // {
  //   title: "Hotels Users",
  //   icon: "hotel",
  //   name: "HotelsUsers",
  //   permission: "ACCOMMODATION",
  // },
  // {
  //   title: "Restaurants",
  //   icon: "restaurant",
  //   name: "Restaurants",
  //   permission: "ACCOMMODATION",
  // },
  // {
  //   title: "Restaurants Users",
  //   icon: "restaurant",
  //   name: "RestaurantsUsers",
  //   permission: "ACCOMMODATION",
  // },
  // {
  //   title: "Companies",
  //   icon: "business",
  //   name: "Companies",
  //   permission: "ACCOMMODATION",
  // },
  // {
  //   title: "Company Requests",
  //   icon: "business",
  //   name: "CompanyRequests",
  //   permission: "COMPANY_REQUESTS",
  // },
  // {
  //   title: "Settings",
  //   icon: "settings",
  //   name: "Settings",
  //   permission: "SETTINGS",
  // },
  // {
  //   title: "Dispatching",
  //   icon: "settings",
  //   name: "Dispatching",
  //   permission: "DISPATCHING_CONFIG"
  // },
  // {
  //   title: "Reservations",
  //   icon: "business",
  //   name: "ReservationsList",
  //   permission: "RESERVATIONS",
  // },
  // {
  //   title: "Events Reports",
  //   icon: "business",
  //   name: "EventsReport",
  //   permission: "EVENTS_REPORTS"
  // },
  // {
  //   title: "Punishment",
  //   icon: "fa-solid fa-ban",
  //   name: "BlockedCaptains",
  //   permission: "PUNISHMENT",
  // },
  // {
  //   title: "Price Rules",
  //   icon: "money",
  //   name: "PriceRules",
  //   permission: "PRICE_RULES"
  // },
  // // {
  // //   title: "Planning",
  // //   icon: "event",
  // //   name: "Events",
  // //    permission: "PLANNING"
  // // },
  // {
  //   title: "Shifts Map",
  //   icon: "map",
  //   name: "ShiftsMap",
  //   permission: "PLANNING"
  // },
  // {
  //   title: "Shifts",
  //   icon: "event",
  //   name: "Shifts",
  //    permission: "PLANNING"
  // },
  // {
  //   title: "Constraints",
  //   icon: "fa-solid fa-ban",
  //   name: "Constraints",
  //   permission: "CONSTRAINTS"
  // },
  // {
  //   title: "Surveys",
  //   icon: "timeline",
  //   name: "Surveys",
  //   permission: "SURVEYS",
  // },
  // {
  //   title: "Reservation Queue",
  //   icon: "list",
  //   name: "ReservationQueue",
  //   permission: "RESERVATION_QUEUE",
  // },
  // {
  //   title: "Terms & Conditions",
  //   icon: "list",
  //   name: "TermsAndConditions",
  //   permission: "T_C",
  // },
  // {
  //   title: "Statistics",
  //   icon: "timeline",
  //   name: "BarStatistics",
  //   permission: "STATISTICS",
  // },
  // {
  //   title: "Vacations",
  //   icon: "hotel",
  //   name: "Vacations",
  // },
  // {
  //   title: "Scheduled Messages",
  //   icon: "list",
  //   name: "scheduled_messages",
  //   permission: "SETTINGS",
  // },
  // {
  //   title: "Max Bookings Counts",
  //   icon: "list",
  //   name: "MaxBookingCount",
  //   permission: "T_C",
  // },
  // {
  //   title: "SMS Codes",
  //   icon: "sms",
  //   name: "sms_codes",
  //   permission: "SMS_CODES",
  // },
  // {
  //   title: "Seasonal Reservations Allowance",
  //   icon: "list",
  //   name: "seasonal_drivers_reservations_allowance_special_cases",
  //   permission: "SETTINGS",
  // },
  // {
  //   title: "Payments",
  //   icon: "list",
  //   name: "payments",
  //   permission: "CARLO_PAYMENT"
  // },
  // {
  //   title: "Lost And Found",
  //   icon: "shopping_basket",
  //   name: "lost_and_found",
  //   permission: "LOST_AND_FOUND",
  // }
];

export default Menu;
